export const tag = 'leasingTemplate';
export const load = async () => {
    const { LeasingComponent } = await import('./leasing.component');
    return {
        component: LeasingComponent,
    };
};
